const state = {
	enterprises_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
